import React from 'react';
import Header from './Header';
import Footer from './Footer';

const Blogs = () => {
    const rawHtml = `
        <style>
            .form-control::placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control:-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
            .form-control::-ms-input-placeholder {
                color: white !important;
                opacity: 0.7;
            }
        </style>
        <!-- Document Wrapper -->
        <div id="wrapper">
            <!-- Content -->
            <section id="content">
                <div class="content-wrap py-0">
                    <!-- Hero Section -->
                    <section id="slider" class="slider-element include-header" style="background: linear-gradient(90deg, rgba(34, 193, 195, 0.06), rgba(253, 187, 45, 0.1));">
                        <div class="container mt-lg-6">
                            <div class="row justify-content-between align-items-center py-lg-6 py-5">
                                <div class="col-lg-6 mb-4 mb-lg-0">
                                    <img src="demos/doctors/images/icons/wave.svg" alt="..." class="position-absolute top-0 start-0 translate-middle d-none d-md-block" width="50">
                                    <h2 class="display-3 fw-bold color all-ts">Blogs & Health Insights</h2>
                                    <p class="lead">Rexroth Nutriscience Pvt. Ltd. – Complete Nutraceutical Blog Collection</p>
                                    <p>Explore our in-depth articles on the trends, technologies, and quality standards that define the future of nutraceuticals.</p>
                                </div>
                                <div class="col-lg-5">
                                    <img src="images/blogs.webp" alt="Blog Insights" class="rounded-6 w-100">
                                </div>
                            </div>
                        </div>
                    </section>

                    <!-- Blog List Section -->
                    <div class="section my-0 bg-transparent">
                        <div class="container">
                            <div class="row g-4">
                                <!-- Blog 1 -->
                                <div class="col-lg-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <div class="d-flex align-items-center mb-3">
                                                <span class="display-6 me-3">📝</span>
                                                <h4 class="mb-0">The Fascinating Rise of Nutraceuticals: How Rexroth Nutriscience Pvt. Ltd. Leads the Way</h4>
                                            </div>
                                            <p class="text-muted mb-3">Discover how nutraceuticals are revolutionizing healthcare by blending nutrition and medicine—explore Rexroth Nutriscience Pvt. Ltd. pioneering role.</p>
                                            <a href="/the-rise-of-nutraceuticals" class="button button-small button-border button-rounded">🔗 Read Full Blog</a>
                                        </div>
                                    </div>
                                </div>

                                <!-- Blog 2 -->
                                <div class="col-lg-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <div class="d-flex align-items-center mb-3">
                                                <span class="display-6 me-3">🛡️</span>
                                                <h4 class="mb-0">Top-Notch Quality in Nutraceuticals: How Rexroth Nutriscience Pvt. Ltd. Sets the Standard</h4>
                                            </div>
                                            <p class="text-muted mb-3">Dive into Rexroth Nutriscience Pvt. Ltd.'s rigorous quality practices that make their nutraceuticals safe, effective, and trustworthy.</p>
                                            <a href="/the-benefits-of-nutraceuticals" class="button button-small button-border button-rounded">🔗 Read Full Blog</a>
                                        </div>
                                    </div>
                                </div>

                                <!-- Blog 3 -->
                                <div class="col-lg-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <div class="d-flex align-items-center mb-3">
                                                <span class="display-6 me-3">🏭</span>
                                                <h4 class="mb-0">Next-Gen Nutraceutical Manufacturing: Inside Rexroth Nutriscience Pvt. Ltd. Smart Factory</h4>
                                            </div>
                                            <p class="text-muted mb-3">Explore the cutting-edge tech behind Rexroth Nutriscience Pvt. Ltd. advanced nutraceutical production process.</p>
                                            <a href="/the-importance-of-nutraceuticals" class="button button-small button-border button-rounded">🔗 Read Full Blog</a>
                                        </div>
                                    </div>
                                </div>

                                <!-- Blog 4 -->
                                <div class="col-lg-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <div class="d-flex align-items-center mb-3">
                                                <span class="display-6 me-3">🌐</span>
                                                <h4 class="mb-0">How Rexroth Nutriscience Pvt. Ltd. Mastered Nutraceutical Compliance Across Borders</h4>
                                            </div>
                                            <p class="text-muted mb-3">Learn how Rexroth Nutriscience Pvt. Ltd. stays ahead of global regulations in the ever-changing nutraceutical space.</p>
                                            <a href="/the-future-of-nutraceuticals" class="button button-small button-border button-rounded">🔗 Read Full Blog</a>
                                        </div>
                                    </div>
                                </div>

                                <!-- Blog 5 -->
                                <div class="col-lg-6">
                                    <div class="card border-0 rounded-6 h-100">
                                        <div class="card-body p-4">
                                            <div class="d-flex align-items-center mb-3">
                                                <span class="display-6 me-3">🚀</span>
                                                <h4 class="mb-0">What's Next for Nutraceuticals? Rexroth Nutriscience Pvt. Ltd. Vision for the Future</h4>
                                            </div>
                                            <p class="text-muted mb-3">Peek into the exciting trends shaping nutraceuticals and how Rexroth Nutriscience Pvt. Ltd. plans to stay ahead.</p>
                                            <a href="/the-importance-of-nutraceuticals" class="button button-small button-border button-rounded">🔗 Read Full Blog</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    `;

    return (
        <>
            <Header />
            <div dangerouslySetInnerHTML={{ __html: rawHtml }} />
            <Footer />
        </>
    );
};

export default Blogs; 